<div class="w2-auction-paused text-center">
	<div class="col-xs-12 w2-auction-paused-icon">
		<i class="fa fa-pause"></i>
	</div>
	<div class="col-xs-12 w2-auction-paused-text">
		{{{auctionPausedMessage}}}
	</div>
</div>